// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from './DispositionsDiagram.generated.tsx/types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositionsDiagram_GetTaxStatusForEntityFragment = (
  { id: string, household: (
    { id: string }
    & { __typename?: 'Household' }
  ), subtype: (
    { id: string }
    & { __typename?: 'CCorpBusinessEntity' | 'GPBusinessEntity' | 'LLCBusinessEntity' | 'LPBusinessEntity' | 'SCorpBusinessEntity' | 'SoleProprietorshipBusinessEntity' }
  ) | (
    { id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus }
    & { __typename?: 'CLTTrust' | 'CRTTrust' | 'CustodialPersonalAccount' | 'DonorAdvisedFund' | 'GRATTrust' | 'ILITTrust' | 'IndividualPersonalAccount' | 'InsurancePersonalAccount' | 'IrrevocableTrust' | 'JointPersonalAccount' | 'PrivateFoundation' | 'QPRTTrust' | 'QualifiedTuitionPersonalAccount' | 'RetirementPersonalAccount' | 'RevocableTrust' | 'SLATTrust' }
  ) }
  & { __typename?: 'Entity' }
);

export type DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragment = (
  { id: string, type: Types.ClientProfileRelationshipType, fromClientProfile: (
    { id: string, isGrantor: boolean, isPrimary: boolean, lastName: string }
    & { __typename?: 'ClientProfile' }
  ), toClientProfile: (
    { id: string, isGrantor: boolean, isPrimary: boolean, lastName: string }
    & { __typename?: 'ClientProfile' }
  ) }
  & { __typename?: 'ClientProfileRelationship' }
);

export type DispositionsDiagram_DispositiveProvisionTemplateFirstDeathFragment = (
  { id: string, displayName: string, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionFirstDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'DispositiveProvisionTemplate' }
);

export type DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragment = (
  { id: string, displayName: string, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionSecondDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'DispositiveProvisionTemplate' }
);

export type DispositionsDiagram_DispositionProvisionFirstDeathFragment = (
  { id: string, dispositionKind: Types.DispositiveProvisionDispositionKind, dispositionAmount?: CurrencyUSD | null, dispositionPercentage?: Percent | null, dispositionFormulaicPercentage?: Percent | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, transferTaxKind: Types.DispositiveProvisionTransferTaxKind, associatedHypotheticalWaterfall?: (
    { id: string }
    & { __typename?: 'EstateWaterfall' }
  ) | null, entity?: (
    { id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: (
      { id: string, displayName: string, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'CCorpBusinessEntity' | 'CLTTrust' | 'CRTTrust' | 'CustodialPersonalAccount' | 'DonorAdvisedFund' | 'GPBusinessEntity' | 'GRATTrust' | 'IrrevocableTrust' | 'LLCBusinessEntity' | 'LPBusinessEntity' | 'PrivateFoundation' | 'QPRTTrust' | 'QualifiedTuitionPersonalAccount' | 'RevocableTrust' | 'SCorpBusinessEntity' | 'SLATTrust' | 'SoleProprietorshipBusinessEntity' }
    ) | (
      { id: string, displayName: string, policies?: Array<(
        OwnershipDiagram_InsurancePolicyFragment
        & { __typename?: 'InsurancePolicy' }
      )> | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'ILITTrust' }
    ) | (
      { id: string, displayName: string, owner?: (
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      ) | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'IndividualPersonalAccount' }
    ) | (
      { id: string, displayName: string, policies?: Array<(
        OwnershipDiagram_InsurancePolicyFragment
        & { __typename?: 'InsurancePolicy' }
      )> | null, beneficiaryDesignations: (
        { primary?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null, contingent?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null }
        & { __typename?: 'BeneficiaryDesignations' }
      ), dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'InsurancePersonalAccount' }
    ) | (
      { id: string, displayName: string, owners?: Array<(
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      )> | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'JointPersonalAccount' }
    ) | (
      { id: string, displayName: string, owner?: (
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      ) | null, beneficiaryDesignations: (
        { primary?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null, contingent?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null }
        & { __typename?: 'BeneficiaryDesignations' }
      ), dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'RetirementPersonalAccount' }
    ) }
    & DispositionsDiagram_GetTaxStatusForEntityFragment
    & { __typename?: 'Entity' }
  ) | null, individual?: (
    { id: string, displayName: string, lastName: string, relationships?: Array<(
      DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragment
      & { __typename?: 'ClientProfileRelationship' }
    )> | null, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioTerminalFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'ClientProfile' }
  ) | null, organization?: (
    { id: string, name: string, clientOrganizationKind?: Types.ClientOrganizationKind | null }
    & { __typename?: 'ClientOrganization' }
  ) | null, testamentaryEntity?: (
    { id: string, displayName: string, inEstateStatus?: Types.EntityInEstateStatus | null, gstStatus?: Types.EntityGstStatus | null, testamentaryEntityKind: Types.TestamentaryEntityKind, accountOwner?: (
      { id: string }
      & { __typename?: 'ClientProfile' }
    ) | null, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioTerminalFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'TestamentaryEntity' }
  ) | null }
  & { __typename?: 'DispositiveProvision' }
);

export type DispositionsDiagram_DispositionProvisionSecondDeathFragment = (
  { id: string, dispositionKind: Types.DispositiveProvisionDispositionKind, dispositionAmount?: CurrencyUSD | null, dispositionPercentage?: Percent | null, dispositionFormulaicPercentage?: Percent | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, transferTaxKind: Types.DispositiveProvisionTransferTaxKind, associatedHypotheticalWaterfall?: (
    { id: string }
    & { __typename?: 'EstateWaterfall' }
  ) | null, entity?: (
    { id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: (
      { id: string, displayName: string, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'CCorpBusinessEntity' | 'CLTTrust' | 'CRTTrust' | 'CustodialPersonalAccount' | 'DonorAdvisedFund' | 'GPBusinessEntity' | 'GRATTrust' | 'IrrevocableTrust' | 'LLCBusinessEntity' | 'LPBusinessEntity' | 'PrivateFoundation' | 'QPRTTrust' | 'QualifiedTuitionPersonalAccount' | 'RevocableTrust' | 'SCorpBusinessEntity' | 'SLATTrust' | 'SoleProprietorshipBusinessEntity' }
    ) | (
      { id: string, displayName: string, policies?: Array<(
        OwnershipDiagram_InsurancePolicyFragment
        & { __typename?: 'InsurancePolicy' }
      )> | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'ILITTrust' }
    ) | (
      { id: string, displayName: string, owner?: (
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      ) | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'IndividualPersonalAccount' }
    ) | (
      { id: string, displayName: string, policies?: Array<(
        OwnershipDiagram_InsurancePolicyFragment
        & { __typename?: 'InsurancePolicy' }
      )> | null, beneficiaryDesignations: (
        { primary?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null, contingent?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null }
        & { __typename?: 'BeneficiaryDesignations' }
      ), dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'InsurancePersonalAccount' }
    ) | (
      { id: string, displayName: string, owners?: Array<(
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      )> | null, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'JointPersonalAccount' }
    ) | (
      { id: string, displayName: string, owner?: (
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      ) | null, beneficiaryDesignations: (
        { primary?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null, contingent?: (
          DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment
          & { __typename?: 'BeneficiaryDesignationGroup' }
        ) | null }
        & { __typename?: 'BeneficiaryDesignations' }
      ), dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioTerminalFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'RetirementPersonalAccount' }
    ) }
    & DispositionsDiagram_GetTaxStatusForEntityFragment
    & { __typename?: 'Entity' }
  ) | null, individual?: (
    { id: string, displayName: string, lastName: string, relationships?: Array<(
      DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragment
      & { __typename?: 'ClientProfileRelationship' }
    )> | null, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioTerminalFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'ClientProfile' }
  ) | null, organization?: (
    { id: string, name: string, clientOrganizationKind?: Types.ClientOrganizationKind | null }
    & { __typename?: 'ClientOrganization' }
  ) | null, testamentaryEntity?: (
    { id: string, displayName: string, inEstateStatus?: Types.EntityInEstateStatus | null, gstStatus?: Types.EntityGstStatus | null, testamentaryEntityKind: Types.TestamentaryEntityKind, accountOwner?: (
      { id: string }
      & { __typename?: 'ClientProfile' }
    ) | null, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioTerminalFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'TestamentaryEntity' }
  ) | null }
  & { __typename?: 'DispositiveProvision' }
);

export type DispositionsDiagram_DispositionProvisionTerminalFragment = (
  { id: string, dispositionKind: Types.DispositiveProvisionDispositionKind, dispositionAmount?: CurrencyUSD | null, dispositionPercentage?: Percent | null, dispositionFormulaicPercentage?: Percent | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, transferTaxKind: Types.DispositiveProvisionTransferTaxKind, associatedHypotheticalWaterfall?: (
    { id: string }
    & { __typename?: 'EstateWaterfall' }
  ) | null, entity?: (
    { id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: (
      { id: string, displayName: string }
      & { __typename?: 'CCorpBusinessEntity' | 'CLTTrust' | 'CRTTrust' | 'CustodialPersonalAccount' | 'DonorAdvisedFund' | 'GPBusinessEntity' | 'GRATTrust' | 'IrrevocableTrust' | 'LLCBusinessEntity' | 'LPBusinessEntity' | 'PrivateFoundation' | 'QPRTTrust' | 'QualifiedTuitionPersonalAccount' | 'RevocableTrust' | 'SCorpBusinessEntity' | 'SLATTrust' | 'SoleProprietorshipBusinessEntity' }
    ) | (
      { id: string, displayName: string, policies?: Array<(
        OwnershipDiagram_InsurancePolicyFragment
        & { __typename?: 'InsurancePolicy' }
      )> | null }
      & { __typename?: 'ILITTrust' | 'InsurancePersonalAccount' }
    ) | (
      { id: string, displayName: string, owner?: (
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      ) | null }
      & { __typename?: 'IndividualPersonalAccount' | 'RetirementPersonalAccount' }
    ) | (
      { id: string, displayName: string, owners?: Array<(
        { id: string, individual?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null }
        & { __typename?: 'Principal' }
      )> | null }
      & { __typename?: 'JointPersonalAccount' }
    ) }
    & DispositionsDiagram_GetTaxStatusForEntityFragment
    & { __typename?: 'Entity' }
  ) | null, individual?: (
    { id: string, displayName: string }
    & { __typename?: 'ClientProfile' }
  ) | null, organization?: (
    { id: string, name: string, clientOrganizationKind?: Types.ClientOrganizationKind | null }
    & { __typename?: 'ClientOrganization' }
  ) | null, testamentaryEntity?: (
    { id: string, displayName: string, inEstateStatus?: Types.EntityInEstateStatus | null, gstStatus?: Types.EntityGstStatus | null, testamentaryEntityKind: Types.TestamentaryEntityKind, accountOwner?: (
      { id: string }
      & { __typename?: 'ClientProfile' }
    ) | null }
    & { __typename?: 'TestamentaryEntity' }
  ) | null }
  & { __typename?: 'DispositiveProvision' }
);

export type DispositionsDiagram_DispositionScenarioTerminalFragment = (
  { id: string, firstGrantorDeath: (
    { id: string }
    & { __typename?: 'ClientProfile' }
  ), dispositiveProvisionsTemplate?: (
    { id: string, displayName: string, dispositiveProvisions: (
      { totalCount: number, edges?: Array<(
        { node?: (
          DispositionsDiagram_DispositionProvisionTerminalFragment
          & { __typename?: 'DispositiveProvision' }
        ) | null }
        & { __typename?: 'DispositiveProvisionEdge' }
      ) | null> | null }
      & { __typename?: 'DispositiveProvisionConnection' }
    ) }
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, secondDeathDispositiveProvisionsTemplate?: (
    { id: string, displayName: string, dispositiveProvisions: (
      { totalCount: number, edges?: Array<(
        { node?: (
          DispositionsDiagram_DispositionProvisionTerminalFragment
          & { __typename?: 'DispositiveProvision' }
        ) | null }
        & { __typename?: 'DispositiveProvisionEdge' }
      ) | null> | null }
      & { __typename?: 'DispositiveProvisionConnection' }
    ) }
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionTerminalFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ), secondDeathDispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionTerminalFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'DispositionScenario' }
);

export type DispositionsDiagram_DispositionScenarioFirstDeathFragment = (
  { id: string, firstGrantorDeath: (
    { id: string }
    & { __typename?: 'ClientProfile' }
  ), dispositiveProvisionsTemplate?: (
    DispositionsDiagram_DispositiveProvisionTemplateFirstDeathFragment
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, secondDeathDispositiveProvisionsTemplate?: (
    DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragment
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionFirstDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ), secondDeathDispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionSecondDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'DispositionScenario' }
);

export type DispositionsDiagram_DispositionScenarioSecondDeathFragment = (
  { id: string, firstGrantorDeath: (
    { id: string }
    & { __typename?: 'ClientProfile' }
  ), dispositiveProvisionsTemplate?: (
    DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragment
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, secondDeathDispositiveProvisionsTemplate?: (
    DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragment
    & { __typename?: 'DispositiveProvisionTemplate' }
  ) | null, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionSecondDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ), secondDeathDispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionSecondDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'DispositionScenario' }
);

export type OwnershipDiagram_InsurancePolicyFragment = (
  { id: string, deathBenefitAmount: CurrencyUSD, survivorship: boolean, policyHolders?: Array<(
    { id: string }
    & { __typename?: 'ClientProfile' }
  )> | null }
  & { __typename?: 'InsurancePolicy' }
);

export type DispositionsDiagram_BeneficiaryDesignationGroupFragment = (
  { id: string, tier: Types.BeneficiaryDesignationTier, associatedHypotheticalWaterfall?: (
    { id: string }
    & { __typename?: 'EstateWaterfall' }
  ) | null, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionFirstDeathFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'BeneficiaryDesignationGroup' }
);

export type DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragment = (
  { id: string, tier: Types.BeneficiaryDesignationTier, associatedHypotheticalWaterfall?: (
    { id: string }
    & { __typename?: 'EstateWaterfall' }
  ) | null, dispositiveProvisions: (
    { totalCount: number, edges?: Array<(
      { node?: (
        DispositionsDiagram_DispositionProvisionTerminalFragment
        & { __typename?: 'DispositiveProvision' }
      ) | null }
      & { __typename?: 'DispositiveProvisionEdge' }
    ) | null> | null }
    & { __typename?: 'DispositiveProvisionConnection' }
  ) }
  & { __typename?: 'BeneficiaryDesignationGroup' }
);

export type DispositionsDiagram_EntityFragment = (
  { id: string, extendedDisplayKind: string, stage: Types.EntityStage, entityKind: Types.EntityKind, entityDiagrams: (
    { edges?: Array<(
      { node?: (
        { id: string, kind: Types.EntityDiagramKind, hideEntitiesListInGroups: boolean, visualizationGroups: (
          { edges?: Array<(
            { node?: (
              { id: string, namespace?: string | null, displayName?: string | null, description?: string | null, nodeIds: Array<string> }
              & { __typename?: 'GraphVisualizationGroup' }
            ) | null }
            & { __typename?: 'GraphVisualizationGroupEdge' }
          ) | null> | null }
          & { __typename?: 'GraphVisualizationGroupConnection' }
        ), firstGrantorDeath?: (
          { id: string }
          & { __typename?: 'ClientProfile' }
        ) | null, nodeConfigurations: Array<(
          { nodeID: string, xPosition?: number | null, yPosition?: number | null, type?: string | null, iconShape?: string | null, tileEmphasis?: string | null, notes?: string | null, width?: number | null, height?: number | null, fontSize?: string | null, entityDiagramConfig?: (
            { hideGroupContents: boolean }
            & { __typename?: 'EntityDiagramNodeConfig' }
          ) | null }
          & { __typename?: 'EntityGraphNodeConfiguration' }
        )>, entity: (
          { id: string }
          & { __typename?: 'Entity' }
        ) }
        & { __typename?: 'EntityDiagram' }
      ) | null }
      & { __typename?: 'EntityDiagramEdge' }
    ) | null> | null }
    & { __typename?: 'EntityDiagramConnection' }
  ), household: (
    { id: string, possiblePrimaryClients: Array<(
      { id: string, displayName: string, lastName: string, dispositionScenarios?: Array<(
        DispositionsDiagram_DispositionScenarioSecondDeathFragment
        & { __typename?: 'DispositionScenario' }
      )> | null }
      & { __typename?: 'ClientProfile' }
    )> }
    & { __typename?: 'Household' }
  ), subtype: (
    { id: string, displayName: string, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioFirstDeathFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'CCorpBusinessEntity' | 'CLTTrust' | 'CRTTrust' | 'CustodialPersonalAccount' | 'DonorAdvisedFund' | 'GPBusinessEntity' | 'GRATTrust' | 'IndividualPersonalAccount' | 'IrrevocableTrust' | 'JointPersonalAccount' | 'LLCBusinessEntity' | 'LPBusinessEntity' | 'PrivateFoundation' | 'QPRTTrust' | 'QualifiedTuitionPersonalAccount' | 'RevocableTrust' | 'SCorpBusinessEntity' | 'SLATTrust' | 'SoleProprietorshipBusinessEntity' }
  ) | (
    { id: string, displayName: string, policies?: Array<(
      OwnershipDiagram_InsurancePolicyFragment
      & { __typename?: 'InsurancePolicy' }
    )> | null, dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioFirstDeathFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'ILITTrust' }
  ) | (
    { id: string, displayName: string, policies?: Array<(
      OwnershipDiagram_InsurancePolicyFragment
      & { __typename?: 'InsurancePolicy' }
    )> | null, beneficiaryDesignations: (
      { primary?: (
        DispositionsDiagram_BeneficiaryDesignationGroupFragment
        & { __typename?: 'BeneficiaryDesignationGroup' }
      ) | null, contingent?: (
        DispositionsDiagram_BeneficiaryDesignationGroupFragment
        & { __typename?: 'BeneficiaryDesignationGroup' }
      ) | null }
      & { __typename?: 'BeneficiaryDesignations' }
    ), dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioFirstDeathFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'InsurancePersonalAccount' }
  ) | (
    { id: string, displayName: string, owner?: (
      { id: string, individual?: (
        { id: string }
        & { __typename?: 'ClientProfile' }
      ) | null }
      & { __typename?: 'Principal' }
    ) | null, beneficiaryDesignations: (
      { primary?: (
        DispositionsDiagram_BeneficiaryDesignationGroupFragment
        & { __typename?: 'BeneficiaryDesignationGroup' }
      ) | null, contingent?: (
        DispositionsDiagram_BeneficiaryDesignationGroupFragment
        & { __typename?: 'BeneficiaryDesignationGroup' }
      ) | null }
      & { __typename?: 'BeneficiaryDesignations' }
    ), dispositionScenarios?: Array<(
      DispositionsDiagram_DispositionScenarioFirstDeathFragment
      & { __typename?: 'DispositionScenario' }
    )> | null }
    & { __typename?: 'RetirementPersonalAccount' }
  ) }
  & DispositionsDiagram_GetTaxStatusForEntityFragment
  & { __typename?: 'Entity' }
);

export type DispositionsDiagramQueryVariables = Types.Exact<{
  entityWhere: Types.EntityWhereInput;
  hypotheticalWaterfallId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DispositionsDiagramQuery = (
  { entities: (
    { edges?: Array<(
      { node?: (
        DispositionsDiagram_EntityFragment
        & { __typename?: 'Entity' }
      ) | null }
      & { __typename?: 'EntityEdge' }
    ) | null> | null }
    & { __typename?: 'EntityConnection' }
  ) }
  & { __typename?: 'Query' }
);

export type DispositionsDiagram_TestamentaryEntityFragment = (
  { id: string, displayName: string, dispositionScenarios?: Array<(
    DispositionsDiagram_DispositionScenarioFirstDeathFragment
    & { __typename?: 'DispositionScenario' }
  )> | null }
  & { __typename?: 'TestamentaryEntity' }
);

export type DispositionsDiagramTestamentaryEntitiesQueryVariables = Types.Exact<{
  testamentWhere: Types.TestamentaryEntityWhereInput;
  hypotheticalWaterfallId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DispositionsDiagramTestamentaryEntitiesQuery = (
  { testamentaryEntities: (
    { edges?: Array<(
      { node?: (
        { id: string }
        & DispositionsDiagram_TestamentaryEntityFragment
        & { __typename?: 'TestamentaryEntity' }
      ) | null }
      & { __typename?: 'TestamentaryEntityEdge' }
    ) | null> | null }
    & { __typename?: 'TestamentaryEntityConnection' }
  ) }
  & { __typename?: 'Query' }
);

export type DispositionsDiagram_ClientProfileFragment = (
  { id: string, displayName: string, lastName: string, dispositionScenarios?: Array<(
    DispositionsDiagram_DispositionScenarioFirstDeathFragment
    & { __typename?: 'DispositionScenario' }
  )> | null }
  & { __typename?: 'ClientProfile' }
);

export type DispositionsDiagramClientProfilesQueryVariables = Types.Exact<{
  clientProfileWhere: Types.ClientProfileWhereInput;
  hypotheticalWaterfallId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DispositionsDiagramClientProfilesQuery = (
  { clientProfiles: (
    { edges?: Array<(
      { node?: (
        DispositionsDiagram_ClientProfileFragment
        & { __typename?: 'ClientProfile' }
      ) | null }
      & { __typename?: 'ClientProfileEdge' }
    ) | null> | null }
    & { __typename?: 'ClientProfileConnection' }
  ) }
  & { __typename?: 'Query' }
);

export const Operations = {
  Query: {
    DispositionsDiagram: 'DispositionsDiagram' as const,
    DispositionsDiagramTestamentaryEntities: 'DispositionsDiagramTestamentaryEntities' as const,
    DispositionsDiagramClientProfiles: 'DispositionsDiagramClientProfiles' as const
  },
  Fragment: {
    DispositionsDiagram_GetTaxStatusForEntity: 'DispositionsDiagram_GetTaxStatusForEntity' as const,
    DispositionsDiagram_ClientProfileMinimalGrantorRelationship: 'DispositionsDiagram_ClientProfileMinimalGrantorRelationship' as const,
    DispositionsDiagram_DispositiveProvisionTemplateFirstDeath: 'DispositionsDiagram_DispositiveProvisionTemplateFirstDeath' as const,
    DispositionsDiagram_DispositiveProvisionTemplateSecondDeath: 'DispositionsDiagram_DispositiveProvisionTemplateSecondDeath' as const,
    DispositionsDiagram_DispositionProvisionFirstDeath: 'DispositionsDiagram_DispositionProvisionFirstDeath' as const,
    DispositionsDiagram_DispositionProvisionSecondDeath: 'DispositionsDiagram_DispositionProvisionSecondDeath' as const,
    DispositionsDiagram_DispositionProvisionTerminal: 'DispositionsDiagram_DispositionProvisionTerminal' as const,
    DispositionsDiagram_DispositionScenarioTerminal: 'DispositionsDiagram_DispositionScenarioTerminal' as const,
    DispositionsDiagram_DispositionScenarioFirstDeath: 'DispositionsDiagram_DispositionScenarioFirstDeath' as const,
    DispositionsDiagram_DispositionScenarioSecondDeath: 'DispositionsDiagram_DispositionScenarioSecondDeath' as const,
    OwnershipDiagram_InsurancePolicy: 'OwnershipDiagram_InsurancePolicy' as const,
    DispositionsDiagram_BeneficiaryDesignationGroup: 'DispositionsDiagram_BeneficiaryDesignationGroup' as const,
    DispositionsDiagram_BeneficiaryDesignationGroupTerminal: 'DispositionsDiagram_BeneficiaryDesignationGroupTerminal' as const,
    DispositionsDiagram_Entity: 'DispositionsDiagram_Entity' as const,
    DispositionsDiagram_TestamentaryEntity: 'DispositionsDiagram_TestamentaryEntity' as const,
    DispositionsDiagram_ClientProfile: 'DispositionsDiagram_ClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const OwnershipDiagram_InsurancePolicyFragmentDoc = gql`
    fragment OwnershipDiagram_InsurancePolicy on InsurancePolicy {
  id
  deathBenefitAmount
  survivorship
  policyHolders {
    id
  }
}
    `;
export const DispositionsDiagram_GetTaxStatusForEntityFragmentDoc = gql`
    fragment DispositionsDiagram_GetTaxStatusForEntity on Entity {
  id
  household {
    id
  }
  subtype {
    id
    ... on GRATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on ILITTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on RevocableTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on SLATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on IrrevocableTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on QPRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on IndividualPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on JointPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on RetirementPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on CustodialPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on CRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on CLTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on DonorAdvisedFund {
      id
      gstStatus
      inEstateStatus
    }
    ... on PrivateFoundation {
      id
      gstStatus
      inEstateStatus
    }
    ... on InsurancePersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
  }
}
    `;
export const DispositionsDiagram_DispositionProvisionTerminalFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionProvisionTerminal on DispositiveProvision {
  id
  dispositionKind
  dispositionAmount
  dispositionPercentage
  dispositionFormulaicPercentage
  associatedHypotheticalWaterfall {
    id
  }
  entity {
    id
    entityKind: kind
    extendedDisplayKind
    subtype {
      id
      displayName
      ... on IndividualPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
      }
      ... on JointPersonalAccount {
        owners {
          id
          individual {
            id
          }
        }
      }
      ... on RetirementPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
      }
      ... on ILITTrust {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
      }
      ... on InsurancePersonalAccount {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
      }
    }
    ...DispositionsDiagram_GetTaxStatusForEntity
  }
  individual {
    id
    displayName
  }
  organization {
    id
    clientOrganizationKind: kind
    name
  }
  recipientKind
  testamentaryEntity {
    id
    displayName
    inEstateStatus
    testamentaryEntityKind: kind
    accountOwner {
      id
    }
    gstStatus
  }
  transferTaxKind
}
    ${OwnershipDiagram_InsurancePolicyFragmentDoc}
${DispositionsDiagram_GetTaxStatusForEntityFragmentDoc}`;
export const DispositionsDiagram_DispositionScenarioTerminalFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionScenarioTerminal on DispositionScenario {
  id
  firstGrantorDeath {
    id
  }
  dispositiveProvisionsTemplate {
    id
    displayName
    dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
      totalCount
      edges {
        node {
          ...DispositionsDiagram_DispositionProvisionTerminal
        }
      }
    }
  }
  secondDeathDispositiveProvisionsTemplate {
    id
    displayName
    dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
      totalCount
      edges {
        node {
          ...DispositionsDiagram_DispositionProvisionTerminal
        }
      }
    }
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionTerminal
      }
    }
  }
  secondDeathDispositiveProvisions(
    orderBy: {direction: ASC, field: DISPOSITION_ORDER}
  ) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionTerminal
      }
    }
  }
}
    ${DispositionsDiagram_DispositionProvisionTerminalFragmentDoc}`;
export const DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragmentDoc = gql`
    fragment DispositionsDiagram_BeneficiaryDesignationGroupTerminal on BeneficiaryDesignationGroup {
  id
  tier
  associatedHypotheticalWaterfall {
    id
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionTerminal
      }
    }
  }
}
    ${DispositionsDiagram_DispositionProvisionTerminalFragmentDoc}`;
export const DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragmentDoc = gql`
    fragment DispositionsDiagram_ClientProfileMinimalGrantorRelationship on ClientProfileRelationship {
  id
  type
  fromClientProfile {
    id
    isGrantor
    isPrimary
    lastName
  }
  toClientProfile {
    id
    isGrantor
    isPrimary
    lastName
  }
}
    `;
export const DispositionsDiagram_DispositionProvisionSecondDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionProvisionSecondDeath on DispositiveProvision {
  id
  dispositionKind
  dispositionAmount
  dispositionPercentage
  dispositionFormulaicPercentage
  associatedHypotheticalWaterfall {
    id
  }
  entity {
    id
    entityKind: kind
    extendedDisplayKind
    subtype {
      id
      displayName
      dispositionScenarios {
        ...DispositionsDiagram_DispositionScenarioTerminal
      }
      ... on IndividualPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
      }
      ... on JointPersonalAccount {
        owners {
          id
          individual {
            id
          }
        }
      }
      ... on ILITTrust {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
      }
      ... on InsurancePersonalAccount {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
        beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
          primary {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
          contingent {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
        }
      }
      ... on RetirementPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
        beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
          primary {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
          contingent {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
        }
      }
    }
    ...DispositionsDiagram_GetTaxStatusForEntity
  }
  individual {
    id
    displayName
    lastName
    relationships {
      ...DispositionsDiagram_ClientProfileMinimalGrantorRelationship
    }
    dispositionScenarios {
      ...DispositionsDiagram_DispositionScenarioTerminal
    }
  }
  organization {
    id
    clientOrganizationKind: kind
    name
  }
  recipientKind
  testamentaryEntity {
    id
    displayName
    inEstateStatus
    testamentaryEntityKind: kind
    accountOwner {
      id
    }
    gstStatus
    dispositionScenarios {
      ...DispositionsDiagram_DispositionScenarioTerminal
    }
  }
  transferTaxKind
}
    ${DispositionsDiagram_DispositionScenarioTerminalFragmentDoc}
${OwnershipDiagram_InsurancePolicyFragmentDoc}
${DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragmentDoc}
${DispositionsDiagram_GetTaxStatusForEntityFragmentDoc}
${DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragmentDoc}`;
export const DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositiveProvisionTemplateSecondDeath on DispositiveProvisionTemplate {
  id
  displayName
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionSecondDeath
      }
    }
  }
}
    ${DispositionsDiagram_DispositionProvisionSecondDeathFragmentDoc}`;
export const DispositionsDiagram_DispositionScenarioSecondDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionScenarioSecondDeath on DispositionScenario {
  id
  firstGrantorDeath {
    id
  }
  dispositiveProvisionsTemplate {
    ...DispositionsDiagram_DispositiveProvisionTemplateSecondDeath
  }
  secondDeathDispositiveProvisionsTemplate {
    ...DispositionsDiagram_DispositiveProvisionTemplateSecondDeath
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionSecondDeath
      }
    }
  }
  secondDeathDispositiveProvisions(
    orderBy: {direction: ASC, field: DISPOSITION_ORDER}
  ) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionSecondDeath
      }
    }
  }
}
    ${DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragmentDoc}
${DispositionsDiagram_DispositionProvisionSecondDeathFragmentDoc}`;
export const DispositionsDiagram_DispositionProvisionFirstDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionProvisionFirstDeath on DispositiveProvision {
  id
  dispositionKind
  dispositionAmount
  dispositionPercentage
  dispositionFormulaicPercentage
  associatedHypotheticalWaterfall {
    id
  }
  entity {
    id
    entityKind: kind
    extendedDisplayKind
    subtype {
      id
      displayName
      dispositionScenarios {
        ...DispositionsDiagram_DispositionScenarioTerminal
      }
      ... on IndividualPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
      }
      ... on JointPersonalAccount {
        owners {
          id
          individual {
            id
          }
        }
      }
      ... on ILITTrust {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
      }
      ... on InsurancePersonalAccount {
        policies {
          ...OwnershipDiagram_InsurancePolicy
        }
        beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
          primary {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
          contingent {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
        }
      }
      ... on RetirementPersonalAccount {
        owner {
          id
          individual {
            id
          }
        }
        beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
          primary {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
          contingent {
            ...DispositionsDiagram_BeneficiaryDesignationGroupTerminal
          }
        }
      }
    }
    ...DispositionsDiagram_GetTaxStatusForEntity
  }
  individual {
    id
    displayName
    lastName
    relationships {
      ...DispositionsDiagram_ClientProfileMinimalGrantorRelationship
    }
    dispositionScenarios {
      ...DispositionsDiagram_DispositionScenarioTerminal
    }
  }
  organization {
    id
    clientOrganizationKind: kind
    name
  }
  recipientKind
  testamentaryEntity {
    id
    displayName
    inEstateStatus
    testamentaryEntityKind: kind
    accountOwner {
      id
    }
    gstStatus
    dispositionScenarios {
      ...DispositionsDiagram_DispositionScenarioTerminal
    }
  }
  transferTaxKind
}
    ${DispositionsDiagram_DispositionScenarioTerminalFragmentDoc}
${OwnershipDiagram_InsurancePolicyFragmentDoc}
${DispositionsDiagram_BeneficiaryDesignationGroupTerminalFragmentDoc}
${DispositionsDiagram_GetTaxStatusForEntityFragmentDoc}
${DispositionsDiagram_ClientProfileMinimalGrantorRelationshipFragmentDoc}`;
export const DispositionsDiagram_DispositiveProvisionTemplateFirstDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositiveProvisionTemplateFirstDeath on DispositiveProvisionTemplate {
  id
  displayName
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionFirstDeath
      }
    }
  }
}
    ${DispositionsDiagram_DispositionProvisionFirstDeathFragmentDoc}`;
export const DispositionsDiagram_DispositionScenarioFirstDeathFragmentDoc = gql`
    fragment DispositionsDiagram_DispositionScenarioFirstDeath on DispositionScenario {
  id
  firstGrantorDeath {
    id
  }
  dispositiveProvisionsTemplate {
    ...DispositionsDiagram_DispositiveProvisionTemplateFirstDeath
  }
  secondDeathDispositiveProvisionsTemplate {
    ...DispositionsDiagram_DispositiveProvisionTemplateSecondDeath
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionFirstDeath
      }
    }
  }
  secondDeathDispositiveProvisions(
    orderBy: {direction: ASC, field: DISPOSITION_ORDER}
  ) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionSecondDeath
      }
    }
  }
}
    ${DispositionsDiagram_DispositiveProvisionTemplateFirstDeathFragmentDoc}
${DispositionsDiagram_DispositiveProvisionTemplateSecondDeathFragmentDoc}
${DispositionsDiagram_DispositionProvisionFirstDeathFragmentDoc}
${DispositionsDiagram_DispositionProvisionSecondDeathFragmentDoc}`;
export const DispositionsDiagram_BeneficiaryDesignationGroupFragmentDoc = gql`
    fragment DispositionsDiagram_BeneficiaryDesignationGroup on BeneficiaryDesignationGroup {
  id
  tier
  associatedHypotheticalWaterfall {
    id
  }
  dispositiveProvisions(orderBy: {direction: ASC, field: DISPOSITION_ORDER}) {
    totalCount
    edges {
      node {
        ...DispositionsDiagram_DispositionProvisionFirstDeath
      }
    }
  }
}
    ${DispositionsDiagram_DispositionProvisionFirstDeathFragmentDoc}`;
export const DispositionsDiagram_EntityFragmentDoc = gql`
    fragment DispositionsDiagram_Entity on Entity {
  id
  entityKind: kind
  extendedDisplayKind
  stage
  entityDiagrams(where: {kind: DISPOSITIONS}) {
    edges {
      node {
        id
        kind
        hideEntitiesListInGroups
        visualizationGroups {
          edges {
            node {
              id
              namespace
              displayName
              description
              nodeIds
            }
          }
        }
        firstGrantorDeath {
          id
        }
        nodeConfigurations {
          nodeID
          xPosition
          yPosition
          type
          iconShape
          tileEmphasis
          notes
          width
          height
          fontSize
          entityDiagramConfig {
            hideGroupContents
          }
        }
        entity {
          id
        }
      }
    }
  }
  household {
    id
    possiblePrimaryClients {
      id
      displayName
      lastName
      dispositionScenarios {
        ...DispositionsDiagram_DispositionScenarioSecondDeath
      }
    }
  }
  subtype {
    id
    displayName
    dispositionScenarios {
      ...DispositionsDiagram_DispositionScenarioFirstDeath
    }
    ... on ILITTrust {
      policies {
        ...OwnershipDiagram_InsurancePolicy
      }
    }
    ... on InsurancePersonalAccount {
      policies {
        ...OwnershipDiagram_InsurancePolicy
      }
      beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
        primary {
          ...DispositionsDiagram_BeneficiaryDesignationGroup
        }
        contingent {
          ...DispositionsDiagram_BeneficiaryDesignationGroup
        }
      }
    }
    ... on RetirementPersonalAccount {
      owner {
        id
        individual {
          id
        }
      }
      beneficiaryDesignations(hypotheticalWaterfallId: $hypotheticalWaterfallId) {
        primary {
          ...DispositionsDiagram_BeneficiaryDesignationGroup
        }
        contingent {
          ...DispositionsDiagram_BeneficiaryDesignationGroup
        }
      }
    }
  }
  ...DispositionsDiagram_GetTaxStatusForEntity
}
    ${DispositionsDiagram_DispositionScenarioSecondDeathFragmentDoc}
${DispositionsDiagram_DispositionScenarioFirstDeathFragmentDoc}
${OwnershipDiagram_InsurancePolicyFragmentDoc}
${DispositionsDiagram_BeneficiaryDesignationGroupFragmentDoc}
${DispositionsDiagram_GetTaxStatusForEntityFragmentDoc}`;
export const DispositionsDiagram_TestamentaryEntityFragmentDoc = gql`
    fragment DispositionsDiagram_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
  dispositionScenarios {
    ...DispositionsDiagram_DispositionScenarioFirstDeath
  }
}
    ${DispositionsDiagram_DispositionScenarioFirstDeathFragmentDoc}`;
export const DispositionsDiagram_ClientProfileFragmentDoc = gql`
    fragment DispositionsDiagram_ClientProfile on ClientProfile {
  id
  displayName
  lastName
  dispositionScenarios {
    ...DispositionsDiagram_DispositionScenarioFirstDeath
  }
}
    ${DispositionsDiagram_DispositionScenarioFirstDeathFragmentDoc}`;
export const DispositionsDiagramDocument = gql`
    query DispositionsDiagram($entityWhere: EntityWhereInput!, $hypotheticalWaterfallId: ID) {
  entities(where: $entityWhere) {
    edges {
      node {
        ...DispositionsDiagram_Entity
      }
    }
  }
}
    ${DispositionsDiagram_EntityFragmentDoc}`;

/**
 * __useDispositionsDiagramQuery__
 *
 * To run a query within a React component, call `useDispositionsDiagramQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositionsDiagramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositionsDiagramQuery({
 *   variables: {
 *      entityWhere: // value for 'entityWhere'
 *      hypotheticalWaterfallId: // value for 'hypotheticalWaterfallId'
 *   },
 * });
 */
export function useDispositionsDiagramQuery(baseOptions: Apollo.QueryHookOptions<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>(DispositionsDiagramDocument, withFetchPolicyContext(options));
      }
export function useDispositionsDiagramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>(DispositionsDiagramDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositionsDiagramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>(DispositionsDiagramDocument, withFetchPolicyContext(options));
        }
export type DispositionsDiagramQueryHookResult = ReturnType<typeof useDispositionsDiagramQuery>;
export type DispositionsDiagramLazyQueryHookResult = ReturnType<typeof useDispositionsDiagramLazyQuery>;
export type DispositionsDiagramSuspenseQueryHookResult = ReturnType<typeof useDispositionsDiagramSuspenseQuery>;
export type DispositionsDiagramQueryResult = Apollo.QueryResult<DispositionsDiagramQuery, DispositionsDiagramQueryVariables>;
export const DispositionsDiagramTestamentaryEntitiesDocument = gql`
    query DispositionsDiagramTestamentaryEntities($testamentWhere: TestamentaryEntityWhereInput!, $hypotheticalWaterfallId: ID) {
  testamentaryEntities(where: $testamentWhere) {
    edges {
      node {
        id
        ...DispositionsDiagram_TestamentaryEntity
      }
    }
  }
}
    ${DispositionsDiagram_TestamentaryEntityFragmentDoc}`;

/**
 * __useDispositionsDiagramTestamentaryEntitiesQuery__
 *
 * To run a query within a React component, call `useDispositionsDiagramTestamentaryEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositionsDiagramTestamentaryEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositionsDiagramTestamentaryEntitiesQuery({
 *   variables: {
 *      testamentWhere: // value for 'testamentWhere'
 *      hypotheticalWaterfallId: // value for 'hypotheticalWaterfallId'
 *   },
 * });
 */
export function useDispositionsDiagramTestamentaryEntitiesQuery(baseOptions: Apollo.QueryHookOptions<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>(DispositionsDiagramTestamentaryEntitiesDocument, withFetchPolicyContext(options));
      }
export function useDispositionsDiagramTestamentaryEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>(DispositionsDiagramTestamentaryEntitiesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositionsDiagramTestamentaryEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>(DispositionsDiagramTestamentaryEntitiesDocument, withFetchPolicyContext(options));
        }
export type DispositionsDiagramTestamentaryEntitiesQueryHookResult = ReturnType<typeof useDispositionsDiagramTestamentaryEntitiesQuery>;
export type DispositionsDiagramTestamentaryEntitiesLazyQueryHookResult = ReturnType<typeof useDispositionsDiagramTestamentaryEntitiesLazyQuery>;
export type DispositionsDiagramTestamentaryEntitiesSuspenseQueryHookResult = ReturnType<typeof useDispositionsDiagramTestamentaryEntitiesSuspenseQuery>;
export type DispositionsDiagramTestamentaryEntitiesQueryResult = Apollo.QueryResult<DispositionsDiagramTestamentaryEntitiesQuery, DispositionsDiagramTestamentaryEntitiesQueryVariables>;
export const DispositionsDiagramClientProfilesDocument = gql`
    query DispositionsDiagramClientProfiles($clientProfileWhere: ClientProfileWhereInput!, $hypotheticalWaterfallId: ID) {
  clientProfiles(where: $clientProfileWhere) {
    edges {
      node {
        ...DispositionsDiagram_ClientProfile
      }
    }
  }
}
    ${DispositionsDiagram_ClientProfileFragmentDoc}`;

/**
 * __useDispositionsDiagramClientProfilesQuery__
 *
 * To run a query within a React component, call `useDispositionsDiagramClientProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositionsDiagramClientProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositionsDiagramClientProfilesQuery({
 *   variables: {
 *      clientProfileWhere: // value for 'clientProfileWhere'
 *      hypotheticalWaterfallId: // value for 'hypotheticalWaterfallId'
 *   },
 * });
 */
export function useDispositionsDiagramClientProfilesQuery(baseOptions: Apollo.QueryHookOptions<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>(DispositionsDiagramClientProfilesDocument, withFetchPolicyContext(options));
      }
export function useDispositionsDiagramClientProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>(DispositionsDiagramClientProfilesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositionsDiagramClientProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>(DispositionsDiagramClientProfilesDocument, withFetchPolicyContext(options));
        }
export type DispositionsDiagramClientProfilesQueryHookResult = ReturnType<typeof useDispositionsDiagramClientProfilesQuery>;
export type DispositionsDiagramClientProfilesLazyQueryHookResult = ReturnType<typeof useDispositionsDiagramClientProfilesLazyQuery>;
export type DispositionsDiagramClientProfilesSuspenseQueryHookResult = ReturnType<typeof useDispositionsDiagramClientProfilesSuspenseQuery>;
export type DispositionsDiagramClientProfilesQueryResult = Apollo.QueryResult<DispositionsDiagramClientProfilesQuery, DispositionsDiagramClientProfilesQueryVariables>;